﻿<template>
    <router-view/>
</template>